"use client";

import { FC, ReactNode } from "react";
import Image from "next/image";
import style from "./style.module.scss";
import { GENERAL } from "@/constants";

type Props = {
  iconSrc?: string;
  label: string;
  value: string;
};

const MetarDetailsItem: FC<Props> = ({ iconSrc, label, value }) => {
  return (
    <div className={style.metarDetailsItemInfo}>
      <span className={style.metarDetailsItemInfoLabelContainer}>
        {iconSrc && <Image src={iconSrc} alt={label} width={GENERAL.IMAGE_SIZES.LARGE} height={GENERAL.IMAGE_SIZES.LARGE} />}
        <span className={style.metarDetailsItemInfoLabel}>{label}</span>
      </span>
      <span className={style.metarDetailsItemInfoValue}>{value}</span>
    </div>
  );
};

export default MetarDetailsItem;


